import {
  getTicketLineThroughClasses,
  getTicketNumberClasses,
} from '@/lib/ticket-styles';
import { Ticket } from '@certhon/models';

interface TicketTitleCellProps {
  ticket: Ticket;
}

/**
 * Renders ticket number and title with status-based styling.
 * Used as the first column in ticket tables.
 *
 * On mobile: This becomes row 1 of the auto-collapsed summary cell.
 * On desktop: This is a regular column.
 */
export function TicketTitleCell({ ticket }: TicketTitleCellProps) {
  const numberClasses = getTicketNumberClasses(ticket.status);
  const titleClasses = getTicketLineThroughClasses(ticket.status);

  return (
    <div className="flex max-w-[400px] min-w-0 items-center gap-2">
      <span className={`flex-shrink-0 ${numberClasses}`}>#{ticket.number}</span>
      <span className={`truncate ${titleClasses}`}>{ticket.title}</span>
    </div>
  );
}
